export const newsActions= {
  ADD: 'ADD',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  REFRESH: 'REFRESH',
  CREATE:'CREATE'
};
export const newsConstants= {
  MAX:6,
};